import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Breadcrumb } from "antd";
import { useSelector, connect } from "react-redux";
import Calendar from "./Calendar";
import { getAllAppointment  } from "../../../../actions/Appointment/appointmentAction";

const Appointment = ({ auth }) => {
  // const [reload, setReload] = useState(false);
  const [updatelist, setUpdatelist] = useState(true);
  const [appointments, setAppointments] = useState([]); 
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchAppointments = async () => {
      const data = await dispatch(getAllAppointment());
      if (data) {
        console.log(data)
        setAppointments(
          data.map((appointment) => ({
            id: appointment.id,
            title: appointment.title, 
            start: appointment.date, 
            
            contact: appointment.Contact_Name && appointment.Contact_Name.length > 0 
            ? appointment.Contact_Name[0].phone 
            : "No phone available",

            service: appointment.Service_Name && appointment.Service_Name.length > 0 
            ? appointment.Service_Name[0].name 
            : "No service available",

            // end: appointment.date,   
            description: appointment.description, 
          }))
        );
      }
    };
    fetchAppointments();
  }, [dispatch]);

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Contact</Breadcrumb.Item>
        <Breadcrumb.Item>Appointment</Breadcrumb.Item>
      </Breadcrumb>

      <div className="site-layout-background main-frame">
          <Calendar data={appointments}
          />
      </div>
    
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(Appointment);
